import { useState } from "react";
import { PrimaryCareApiResponse } from "../../../api/bigQuery/pharmaPrimaryCareOrders";
import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";

export interface PrimaryCareTableState {
  data: PrimaryCareApiResponse | undefined;
  loading: boolean;
  error: string | null;
  showInlineLoader: boolean;
}

export interface UsePrimaryCareTableDataReturn {
  primaryCareState: PrimaryCareTableState;
  setPrimaryCareState: React.Dispatch<
    React.SetStateAction<PrimaryCareTableState>
  >;
  tableData: AestraPrimaryCareTable[];
  setTableData: React.Dispatch<React.SetStateAction<AestraPrimaryCareTable[]>>;
}

export const usePrimaryCareTableData = (): UsePrimaryCareTableDataReturn => {
  const [tableData, setTableData] = useState<AestraPrimaryCareTable[]>([]);
  const [primaryCareState, setPrimaryCareState] =
    useState<PrimaryCareTableState>({
      data: undefined,
      loading: false,
      error: null,
      showInlineLoader: false,
    });

  return {
    primaryCareState,
    setPrimaryCareState,
    tableData,
    setTableData,
  };
};
